import React, { FC } from 'react'

import { AutocompleteableItem, User } from 'types'
import { AutocompleteSelect } from 'components/AutocompleteSelect'

interface AddUserDropdownProps {
  addUser: (item: AutocompleteableItem, selectedFolder?:number []) => void
  excludedMembers: User[]
  users: []
  userType: any
  selectedFolder?: any
  onSelectionHandler?: any
  projectId?: number | undefined
  templateDocumentId?:number | undefined
}

export const AddUserDropdown: FC<AddUserDropdownProps> = ({
  addUser,
  excludedMembers,
  users,
  userType,
  selectedFolder,
  onSelectionHandler,
  projectId,
  templateDocumentId
}) => {
  const excludedMemberIds = new Set(excludedMembers.map(({ id }) => id))
  const autocompleteItems = users
    .filter(({ id }) => !excludedMemberIds.has(id))
    .map(({ id, firstName, lastName, email }) => ({
      id: id as number,
      payload: email,
      value: `${firstName} ${lastName} (${email})`,
    }))

  return (
    <AutocompleteSelect
    projectId={projectId}
    templateDocumentId={templateDocumentId}
      items={autocompleteItems}
      onSelect={addUser}
      userType={userType}
      selectedFolder={selectedFolder}
      onSelectionHandler={onSelectionHandler}
    />
  )
}